import {createContext} from 'react'
import type {Subscription} from '@package/shared'
import type {SessionResponse, SubscribeRequest} from '@app/api-resolver/router'

export type StripeContextValue = {
  createPortalSession: () => Promise<SessionResponse | null>
  creatingPortalSession: boolean

  subscribe: (request: SubscribeRequest) => Promise<SessionResponse>
  subscribing: boolean

  subscriptions: Subscription[]
  loadingSubscriptions: boolean
}

export const StripeContext = createContext<StripeContextValue>({} as StripeContextValue)
